import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';

import { AuthService } from '../../../../providers/auth.service';
import { SharedClientService } from '../../shared/services/shared-client.service';
import { CreditCardStateService } from './store/credit-card-state.service';
import { NotificationService } from '../../../shared/notification/notification.service';
import { BillingStateService } from '../store/billing-state.service';

import { CreditCardState } from './store/credit-card-state';
import { BillingState } from '../store/billing-state';

import { default as swal } from 'sweetalert2';

declare var Stripe: any;


export class CreditCardComponent implements OnInit, AfterViewInit, OnDestroy {
	public stripeCardElement: any;
	public client: any;
	public loading: boolean = false;
	public removing: boolean = false;
	public cardPaymentConsent: boolean = false;
	public stripeValidationError = '';
	public state: CreditCardState;
	public billingState: BillingState;
	public stripeCardHolderName = '';

	private setupIntent: any;
	private stripe: any;
	private unsubscribe$ = new Subject();

	constructor(
		private authService: AuthService,
		private sharedClientService: SharedClientService,
		private billingStateService: BillingStateService,
		private notificationService: NotificationService,
		private creditCardStateService: CreditCardStateService) { }

	public ngOnInit(): void {
		this.subscribeToState();
		this.subscribeToBillingState();
	}

	public ngAfterViewInit(): void {
		this.getClient();
		this.getClientCard();
		this.initStripeCard();
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public onAddNewCard() {
		if (this.loading || !this.cardPaymentConsent || this.stripeValidationError || this.state.loading || this.removing || !this.stripeCardHolderName) {
			return;
		}

		this.loading = true;
		this.stripeValidationError = '';
		this.billingStateService.setActionInProgress(true);
		this.sharedClientService.getClientBillingPaymentSetupIntent(this.authService.userId).subscribe(
			(setupIntent) => {
				let that = this;
				this.stripe.handleCardSetup(
					setupIntent.client_secret, this.stripeCardElement, {
						payment_method_data: {
							billing_details: {
								name: that.stripeCardHolderName,
								email: that.client.email,
								phone: that.client.phone
							}
						}
					}
				).then((result) => {
					if (result.error) {
						that.loading = false;
						that.stripeValidationError = 'Something went wrong adding the card, please try again later or contact us at contact@hackajob.co!';
					} else {
						// send new stripe_payment_method_id
						that.updateClientStripePaymentMethodId(result.setupIntent.payment_method);
					}

					that.stripeCardHolderName = '';
					that.notificationService.emitEventAction({action: 'reload-notifications'});
					that.billingStateService.setActionInProgress(false);
				});
			}
		);
	}

	public onRemoveCard(): void {
		if (this.loading || this.removing || this.billingState.actionInProgress) {
			return;
		}

		swal({
			title: 'Are you sure you want to remove your payment details?',
			text: 'Your subscription auto-renewal will not work anymore.',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#E06160',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			allowEscapeKey: false,
			reverseButtons: true
		}).then(() => {
			this.removing = true;
			this.billingStateService.setActionInProgress(true);
			this.updateClientStripePaymentMethodId(null);
		}, () => undefined);
	}

	public reloadData(): void {
		this.creditCardStateService.resetFirstLoad();
		this.getClientCard();
		this.stripeCardElement.clear();
	}

	private subscribeToState() {
		this.creditCardStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.state = state;
			}
		);
	}

	private subscribeToBillingState() {
		this.billingStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.billingState = state;
			}
		);
	}

	private initStripeCard(): void {
		this.stripe = Stripe(process.env.STRIPE_PUBLIC_KEY);

		let elements = this.stripe.elements();
		let style = {
			base: {
				'iconColor': '#444444',
				'color': '#31325f',
				'fontWeight': 400,
				'fontFamily':
					'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
				'fontSmoothing': 'antialiased',
				'fontSize': '14px',
				'::placeholder': {
					color: '#aab7c4',
				},
				':-webkit-autofill': {
					color: '#666ee8',
				},
			},
		};

		this.stripeCardElement = elements.create('card', {
			hidePostalCode: true,
			style
		});
		this.stripeCardElement.mount('#credit-card-element');
		this.stripeCardElement.addEventListener('change', ({error}) => {
			this.stripeValidationError = error ? error.message : '';
		});
	}

	private updateClientStripePaymentMethodId(paymentMethodId?: string) {
		this.sharedClientService.updateClientStripePaymentMethodId(this.authService.userId, {stripe_payment_method_id : paymentMethodId}).subscribe(
			(resp) => {
				if (paymentMethodId) {
					this.getClientCard();
					this.stripeCardElement.clear();
				} else {
					this.creditCardStateService.setCreditCard(null);
				}

				this.loading = false;
				this.removing = false;
				this.notificationService.emitEventAction({action: 'reload-notifications'});
				this.billingStateService.setActionInProgress(false);
			}
		);
	}

	private getClientCard(): void {
		this.creditCardStateService.setLoading(true);
		this.sharedClientService.getClientBillingCardDetails(this.authService.userId).subscribe(
			(card) => {
				this.creditCardStateService.setCreditCard(card);
			},
			(error) => {
				this.creditCardStateService.setCreditCard(null);

				// if there is other error than 404 set loading on true in order to not client to make future wrong actions
				if (error.status !== 404) {
					this.creditCardStateService.setLoading(true);
				}
			}
		);
	}

	private getClient(): void {
		this.sharedClientService.get(this.authService.userId).subscribe(
			(client) => {
				this.client = client;
			}
		);
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedClientService }, { type: BillingStateService }, { type: NotificationService }, { type: CreditCardStateService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/credit-card/credit-card.component.ts